import { render, staticRenderFns } from "./SelectMainArtist.vue?vue&type=template&id=a1986b72&"
import script from "./SelectMainArtist.vue?vue&type=script&lang=js&"
export * from "./SelectMainArtist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports